// DOCX → markdown extraction (Session 19AD).
//
// Uses mammoth's convertToMarkdown — industrial-grade, preserves headings /
// lists / emphasis. Mammoth runs in the browser (we feed it ArrayBuffer; no
// node fs dependency).
//
// Mammoth ships no TS types, so we declare the slim slice we use.
import mammothImport from 'mammoth';
import { ParseError } from '../types.js';
// Mammoth's published d.ts predates convertToMarkdown — cast through unknown.
const mammoth = mammothImport;
export async function extractDocx(file) {
    const start = Date.now();
    let buffer;
    try {
        buffer = await file.arrayBuffer();
    }
    catch (err) {
        throw new ParseError('failed to read .docx as ArrayBuffer', err);
    }
    let result;
    try {
        result = await mammoth.convertToMarkdown({ arrayBuffer: buffer });
    }
    catch (err) {
        throw new ParseError('mammoth failed to convert .docx', err);
    }
    const warnings = result.messages
        .filter((m) => m.type === 'warning' || m.type === 'error')
        .map((m) => `${m.type}: ${m.message}`);
    return {
        markdown: result.value,
        meta: {
            sourceFormat: 'docx',
            tier: 'tier1',
            durationMs: Date.now() - start,
            warnings,
        },
    };
}
//# sourceMappingURL=index.js.map